/******************************************************************************
 *
 * WorkItemSummary
 *
 * Displays summary information of the selected Work Item.
 *
 ******************************************************************************/

import React from "react";

export default function WorkItemSummary({

    workItem

}) {

    if (!workItem) {

        return null;

    }

    const priorityColor = {

        LOW: "#16A34A",
        MEDIUM: "#F59E0B",
        HIGH: "#EA580C",
        CRITICAL: "#DC2626"

    }[workItem.priority] || "#6B7280";

    const statusColor = {

        OPEN: "#6B7280",
        IN_PROGRESS: "#2563EB",
        COMPLETED: "#16A34A",
        CANCELLED: "#DC2626"

    }[workItem.status] || "#6B7280";

    return (

        <div
            className="card border-0 shadow-sm mb-3"
            style={{
                borderRadius: "12px"
            }}
        >

            {/* Header */}

            <div
                className="card-header border-0 text-white py-2"
                style={{
                    background:
                        "linear-gradient(135deg,#2563EB,#1E40AF)",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px"
                }}
            >

                <div className="fw-semibold">

                    📋 Work Item Summary

                </div>

            </div>

            <div className="card-body py-3">

                {/* Row 1 */}

                <div className="row g-3 align-items-center">

                    <div className="col-md-3">

                        <small className="text-muted">

                            Priority

                        </small>

                        <div>

                            <span
                                className="badge"
                                style={{
                                    background: priorityColor
                                }}
                            >
                                {workItem.priority || "-"}
                            </span>

                        </div>

                    </div>

                    <div className="col-md-3">

                        <small className="text-muted">

                            Status

                        </small>

                        <div>

                            <span
                                className="badge"
                                style={{
                                    background: statusColor
                                }}
                            >
                                {workItem.status || "-"}
                            </span>

                        </div>

                    </div>

                    <div className="col-md-3">

                        <small className="text-muted">

                            Due Date

                        </small>

                        <div className="fw-semibold">

                            {workItem.target_completion_date || "-"}

                        </div>

                    </div>

                    <div className="col-md-3">

                        <small className="text-muted">

                            Est. Hours

                        </small>

                        <div className="fw-semibold">

                            {workItem.estimated_hours || 0}

                        </div>

                    </div>

                </div>

                {/* Description */}

                <div className="mt-3">

                    <small className="text-muted">

                        Description

                    </small>

                    <div
                        className="mt-1"
                        style={{
                            fontSize: "14px"
                        }}
                    >

                        {workItem.description || "-"}

                    </div>

                </div>

            </div>

        </div>

    );

}